/* eslint-disable */
// http://s-gateway-ci.k8s.zhihuiya.com/s-analytics-marketplace-api/marketplace/swagger-ui.html#/
export function makeMarketplaceUrl(server) {
    const M = (j) => server + '/backoffice/proxy/marketplace-api' + j;
    return {
        marketplace: {
            auditList: M('/platform/audit/list'),
            auditPass: M('/platform/audit/navigation/${navigation_id}'),
            auditReject: M('/platform/reject/navigation/${navigation_id}'),
            navigationDetail: M('/navigation/${navigation_id}/details'),
            agencyList: M('/platform/agency/list'),
            agencyAction: M('/platform/agency/${agency_id}'),
            logoUpload: M('/platform/agency/LOGO/upload'),
            agentList: M('/platform/agent/list'),
            agentAdd: M('/platform/agent'),
            agentRemove: M('/platform/agent/${agent_id}'),
            getAgentAccessList: M('/platform/agency/access/log/list'),
            getAgentAccessExport: M('/platform/agency/access/log/export'),
            getAgentBuyList: M('/platform/agency/buy/summary'),
            getAgentBuyExport: M('/platform/agency/buy/summary/export'),
            getAgentSubscribeList: M('/platform/agency/subscribe/summary'),
            getAgentSubscribeExport: M('/platform/agency/subscribe/summary/export'),
            getNavigationBuyList: M('/platform/navigation/buy/summary'),
            getNavigationBuyExport: M('/platform/navigation/buy/summary/export'),
            getNavigationSubscribeList: M('/platform/navigation/subscribe/summary'),
            getNavigationSubscribeExport: M('/platform/navigation/subscribe/summary/export'),
            postPlatformExport: M('/platform/export'),
            postPlatformSummary: M('/platform/summary'),
            postPlatformOrder: M('/platform/navigation/order/list'),
            postPlatformAccess: M('/platform/access/log/list'),
        },
    };
}
